import { render, staticRenderFns } from "./InCompleteAccount.vue?vue&type=template&id=510b8204&"
import script from "./InCompleteAccount.vue?vue&type=script&lang=js&"
export * from "./InCompleteAccount.vue?vue&type=script&lang=js&"
import style0 from "./InCompleteAccount.vue?vue&type=style&index=0&id=510b8204&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports